export { default } from './FreeCrypto';
